import { Customer, Discount, Order, OrderApi } from './types';
import bridge from '../../bridge/bridge';
import {
  AddCustomerRequest,
  AddDiscountRequest,
  AddDiscountResponse,
  GetCustomerRequest,
  GetCustomerResponse,
  RemoveCustomerRequest,
  RemoveDiscountRequest,
  RetrieveOrderRequest,
  RetrieveOrderResponse,
} from './actions';

/**
 * Adds customer to the order.
 *
 * @param customer Customer to add to order.
 * @throws {RequestError}
 */
async function addCustomer(customer: Customer): Promise<void> {
  await bridge.app.postMessage(new AddCustomerRequest(customer));
}

/**
 * Retrieves customer.
 *
 * @returns Customer tied to the order.
 * @throws {RequestError}
 */
async function getCustomer(): Promise<Customer> {
  const response = (await bridge.app.postMessage(
    new GetCustomerRequest()
  )) as GetCustomerResponse;

  return response.value.customer;
}

/**
 * Removes customer from the order.
 *
 * @throws {RequestError}
 */
async function removeCustomer(): Promise<void> {
  await bridge.app.postMessage(new RemoveCustomerRequest());
}

/**
 * Adds a discount to the order.
 *
 * @param discount Discount to add.
 * @returns UID of the added discount.
 * @throws {RequestError}
 */
async function addDiscount(discount: Discount): Promise<string> {
  const response = (await bridge.app.postMessage(
    new AddDiscountRequest(discount)
  )) as AddDiscountResponse;

  return response.value.uid;
}

/**
 * Removes discount from the order.
 *
 * @param discountId Id of the discount to remove.
 * @throws {RequestError}
 */
async function removeDiscount(discountId: string): Promise<void> {
  await bridge.app.postMessage(new RemoveDiscountRequest(discountId));
}

/**
 * Retrieves the current order.
 *
 * @returns Current order object.
 * @throws {RequestError}
 */
async function retrieve(): Promise<Order> {
  const response = (await bridge.app.postMessage(
    new RetrieveOrderRequest()
  )) as RetrieveOrderResponse;

  return response.value.order;
}

const order: OrderApi = {
  addCustomer,
  getCustomer,
  addDiscount,
  removeCustomer,
  removeDiscount,
  retrieve,
};

export { order };
